import React, { useEffect, useState } from 'react';
import { getNameInitials } from 'src/shared/utils/src';
import CustomImage from './CustomImageView';
import { Checkmark } from 'react-ionicons';

type IProps = {
  name?: string
  imageUrl?: string
  customContainerStyles?: string
  customAvatarStyles?: string
  customImageStyles?: string
  onImageClick?: () => void,
  resizeMode?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down';
  checkMark?: boolean
}

const ProfileImageView: React.FC<IProps> = ({ 
    customContainerStyles,
    customAvatarStyles,
    customImageStyles,
    name,
    imageUrl,
    resizeMode,
    onImageClick,
    checkMark = false }) => {

  const [nameInitials, setNameInitials] = useState<string>();

  useEffect(() => {
    if (name) {
      setNameInitials(getNameInitials(name));
    }
  }, [name]);


  return (
    <div className={`avatar ${customContainerStyles ? customContainerStyles : ''}`}>
      <CustomImage 
        url={imageUrl} 
        customImageStyles={customImageStyles} 
        onPressImage={onImageClick} 
        resizeMode={resizeMode} 
        nameInitials={nameInitials}
        customAvatarStyles={customAvatarStyles}
      />
      {checkMark && <div className='avatar-checkmark'><Checkmark color={'#FFFFFF'} /></div> }
    </div>
  );
};

export default ProfileImageView;
